import client from './client';
import { getAccessToken } from './localstorage';
import { decodeBase64Blob } from './waste-invoice'

export async function downloadWasteTransaction({ transactionDomainId }) {
  const bearerToken = getAccessToken();
  if (!bearerToken) throw new Error('no_access_token');

  const endpoint = `/api/multiutility/waste/download/transactions/${transactionDomainId}`;
  const resp = await client.get(endpoint, {
    headers: { Authorization: bearerToken },
    responseType: 'blob',
  });

  const disposition = resp.headers['content-disposition'] || '';
  const filenameStarMatch = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const rawName = filenameStarMatch?.[1] || filenameMatch?.[1] || `${transactionDomainId}`;
  const filename = decodeURIComponent(rawName);
  const contentType = resp.headers['content-type'] || 'application/octet-stream';
  const blob = await decodeBase64Blob(resp.data, contentType);

  return { blob, contentType, filename };
}